import { IconDefinition, IconPack, library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight as faArrowRightLight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import {
  faArrowRight as faArrowRightRegular,
  faLongArrowLeft as faLongArrowLeftRegular,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowRight as faArrowRightSolid,
  faBookmark,
  faCheckCircle,
  faShieldCheck as faShieldCheckSolid,
} from '@fortawesome/pro-solid-svg-icons';

export function registerIcons() {
  const icons: (IconDefinition | IconPack)[] = [
    faArrowRightLight,
    faArrowRightRegular,
    faArrowRightSolid,
    faLongArrowLeftRegular,
    faCheckCircle,
    faBookmark,
    faShieldCheckSolid,
  ];
  library.add(...icons);
}
